import React, { Fragment } from "react";

import {
  AssignDeviceDropdownItem,
  AssignDeviceModalItem,
} from "../../../../../../../components/devices/assignDeviceItem";
import {
  MergeDeviceDropdownItem,
  MergeDeviceModalItem,
} from "../../../../../../../components/devices/mergeDeviceItem";
import { DeviceDropdownMenu } from "../../../../../../../components/devices/DeviceDropdownMenu";
import { NotMobile, Mobile } from "../../../../../../../hocs/Responsive";
import { DeviceActionsToggle } from "../../../../../../../components/devices/DeviceActionsDialog";

export const RequestedDevicesDropdownActions = ({ identifier, name, type }) => {
  const dropdownItems = [
    <AssignDeviceDropdownItem
      device={{ identifiers: [identifier], name, type }}
      messageId={"assign_to_group"}
    />,
    <MergeDeviceDropdownItem deviceToMerge={{ id: identifier, type, name }} />,
  ];

  const modalItems = [
    <AssignDeviceModalItem
      device={{ identifiers: [identifier], name, type }}
      messageId={"assign_to_group"}
    />,
    <MergeDeviceModalItem deviceToMerge={{ id: identifier, type, name }} />,
  ];

  return (
    <Fragment>
      <Mobile>
        <DeviceActionsToggle
          deviceName={name}
          menuItems={modalItems}
          ariaDeviceName={name}
        />
      </Mobile>
      <NotMobile>
        <DeviceDropdownMenu menuItems={dropdownItems} deviceName={name} />
      </NotMobile>
    </Fragment>
  );
};
